import { createIndexedDBStore } from '@/stores/_base/createIndexedDBStore'
import { createArchivedOrderService } from '@/services/order/archivedOrderService'
import type { OrderPenArchive } from '@farmfree/common/types/order/orderPenArchive'

const archivedOrderService = createArchivedOrderService()

export const useArchivedOrderStore = createIndexedDBStore<OrderPenArchive>({
  storeId: 'archivedOrder',
  tableName: 'archivedOrders',
  versionField: 'orderPenArchiveVersion',
  service: {
    getModified: (companyId: string, since: number) =>
      archivedOrderService.getModified(companyId, since),
    getDeleted: (companyId: string) => archivedOrderService.getDeleted(companyId),
  },
  options: {
    debug: false,
  },
})
